// extracted by mini-css-extract-plugin
export default {"minMax":"styles_minMax__TYsW+","to":"styles_to__UFyNx"};